import { useAuthContext } from '@/contexts/AuthContext';
import { useOrgLogo } from '@/hooks/useOrgLogo';
import { getOrgInitials } from '@/lib/org-branding';
import { PhotoUploadSheet } from '@/components/common/PhotoUploadSheet';

/**
 * Logo da organização: avatar circular + bottom sheet (mesma UI do app do
 * cliente). A validação (inclui SVG, ≤2MB) vive em useOrgLogo.
 */
export function LogoOrganizacaoCard() {
  const { organization } = useAuthContext();
  const { uploadLogo, removeLogo, isUploading, isRemoving } = useOrgLogo();

  return (
    <div className="ow-card p-6 flex justify-center">
      <PhotoUploadSheet
        imageUrl={organization?.logo_url}
        fallback={getOrgInitials(organization?.nome)}
        onPick={uploadLogo}
        onRemove={removeLogo}
        busy={isUploading || isRemoving}
        canRemove={!!organization?.logo_url}
        accept="image/png,image/jpeg,image/svg+xml,image/webp"
        caption={
          organization?.nome ? (
            <div className="text-center text-lg font-bold text-foreground">{organization.nome}</div>
          ) : null
        }
      />
    </div>
  );
}
